module.exports = __webpack_public_path__ + "static/media/mt-harissa.d27a025e.mp3";